
const Discover = () => {
    return (
        <div>
            TODO: Graph visualization of relationships among current employees
        </div>
    );
};

export default Discover;